import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardDateHeadersOption')(function discardDateHeadersOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardDateHeadersOption.js.map